module.exports = __webpack_public_path__ + "img/wanj.0333e7f7.png";